module.exports = __webpack_public_path__ + "media/recipes/54-28322fef.png";